import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/CategoriaCard.css'; // Crearemos este archivo para estilos

function CategoriaCard({ id, nombre, imagenUrl }) {
  // URL de imagen por defecto si no se proporciona una
  const defaultImageUrl = 'https://via.placeholder.com/300x200?text=Categoria';
  
  // Add debugging log to verify the name is being received
  useEffect(() => {
    console.log('CategoriaCard rendering with nombre:', nombre);
  }, [nombre]);

  return (
    <Link to={`/recomendaciones/${id}`} className="categoria-card frontend-categoria-card">
      <div className="categoria-card-image-container">
        <img 
          src={imagenUrl || defaultImageUrl} 
          alt={`Imagen de ${nombre}`}
          onError={(e) => { e.target.onerror = null; e.target.src=defaultImageUrl }} // Fallback si la imagen principal falla
        />
      </div>
      <div className="categoria-card-content">
        <h3 className="frontend-categoria-nombre">{nombre || `Categoría ${id}`}</h3>
        {/* Podrías añadir la descripción aquí si la pasas como prop */}
      </div>
    </Link>
  );
}

export default CategoriaCard; 